import React, { VFC } from 'react';
import PaymentQRCode from './PaymentQRCode';
import {
    MembershipPaymentStatus,
    MembershipValidityIntervalInterface,
} from 'components/interfaces/MembershipPaymentInterface';
import styles from 'components/login/Landing.module.scss';
import { H3 } from 'components/typography';
import PaymentDetailsBlock from 'components/login/PaymentDetailsBlock';
import stylesBlocks from 'components/blocks/BasicDetailsBlock.module.scss';
import MembershipPaymentInfoBlock from 'components/login/MembershipPaymentInfoBlock';
import Icon from 'components/icon/Icon';
import Check from 'components/icon/icons/green_check.svg';
import H2 from 'components/typography/H2';
import { useTranslation } from 'utils/localization';
import { DisciplineEnum } from 'submodules/api_middleware';
import PayBlock from 'components/login/PayBlock';

interface Props {
    membershipInterval?: MembershipValidityIntervalInterface;
    amount: number;
    administrationFee?: number;
    bankAccount: string;
    iban: string;
    variableSymbol?: string;
    dueDate: string;
    discipline: DisciplineEnum;
    status?: MembershipPaymentStatus;
    applicationId?: string;
    personId?: string;
}
const MembershipPayment: VFC<Props> = ({
    membershipInterval,
    amount,
    administrationFee,
    bankAccount,
    iban,
    variableSymbol,
    dueDate,
    discipline,
    status,
    applicationId,
    personId,
}) => {
    const { t } = useTranslation();
    const paid = status === MembershipPaymentStatus.Paid;

    // The payment is paid, return success screen
    if (paid) {
        return (
            <div className={styles.successText}>
                <Icon icon={Check} className={styles.icon} />
                <H2>
                    {t('Toast.payment_state_completed_message_title') as string}
                </H2>
                <div>{t('Toast.payment_state_completed_message')}</div>
            </div>
        );
    }

    return (
        <div>
            {/* Heading */}
            <H3 className={styles.secondTitle}>
                {
                    t(
                        status === MembershipPaymentStatus.Pending
                            ? 'Dashboard.waitingForPaymentProcessing'
                            : 'Payment.finishSignUp'
                    ) as 'string'
                }
            </H3>

            {/* Payment information */}
            <div className={stylesBlocks.flexStart}>
                <MembershipPaymentInfoBlock
                    validity={membershipInterval}
                    dueDate={dueDate}
                    discipline={discipline}
                    amount={amount}
                />
                {status !== MembershipPaymentStatus.Pending && (
                    <>
                        <PaymentDetailsBlock
                            bankAccount={bankAccount}
                            variableSymbol={variableSymbol}
                            amount={amount}
                        />
                        <PayBlock
                            applicationId={applicationId}
                            amount={amount}
                            administrationFee={administrationFee}
                            personId={personId}
                        />
                    </>
                )}
            </div>

            {/* QR Code */}
            {iban && amount && status !== MembershipPaymentStatus.Pending && (
                <div className={stylesBlocks.flexStart}>
                    <div className={stylesBlocks.flexRowCenter}>
                        <PaymentQRCode
                            recipientIBAN={iban}
                            totalAmountWithVat={amount}
                            variable_symbol={variableSymbol}
                        />
                        <span style={{ marginLeft: '2rem', color: 'red' }}>
                            Upozorňujeme, že při platbě na účet nebo přes QR kód
                            se jedná o bankovní převod. Tato platba bude do
                            systému nahrána nejdříve následující pracovní den.
                            Pokud potřebujete člena aktivního ihned, využijte
                            prosím tlačítko “ZAPLATIT KARTOU”.
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default MembershipPayment;
